function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "icons8-laptop-play-video",
  d: "M9.75,8a4.99,4.99,0,0,0-5,4.941V40.118a4.823,4.823,0,0,0,.7,2.471H2.25A1.243,1.243,0,0,0,1,43.823,6.233,6.233,0,0,0,7.25,50h47.5A6.233,6.233,0,0,0,61,43.824a1.243,1.243,0,0,0-1.25-1.235h-3.2a4.823,4.823,0,0,0,.7-2.471V12.941A4.99,4.99,0,0,0,52.25,8Zm0,2.471h42.5a2.466,2.466,0,0,1,2.5,2.471V40.118a2.466,2.466,0,0,1-2.5,2.471H9.75a2.466,2.466,0,0,1-2.5-2.471V12.941A2.466,2.466,0,0,1,9.75,10.471ZM23.5,16.647V36.412L41,26.529Zm2.5,4.2,10,5.682L26,32.211ZM4.015,45.059h53.97a3.519,3.519,0,0,1-3.235,2.471H7.25A3.519,3.519,0,0,1,4.015,45.059Z",
  transform: "translate(-1 -8)",
  fill: "#fff"
});

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 42,
    viewBox: "0 0 60 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default ForwardRef;